const requireAuth = (store) => {
  const { dispatch, getState } = store;
  return (nextState, replace, callback) => {
    const currentState = getState();

    const userData = currentState.global.data.user;
    const merchantData = currentState.global.data.merchant;
    const accessToken =
      (userData && userData.accessToken) || (userData && userData.access_token);
    //const tokenTime = accessToken ? Auth.getTokenLifeTime(accessToken) : undefined;
    // if (tokenTime < 200) {
    //   dispatch({ type: 'RESET' });
    // }
    if (!accessToken) {
      localStorage.clear();
      replace('/login');
    } else if (merchantData) {
      try {
        dispatch({ type: 'SELECTED_ACCOUNT', payload: merchantData });
      } catch (e) {
        localStorage.clear();
        throw e;
      }
    }
    return callback();
  };
};

export default requireAuth;
